import * as c from "./constant";

export const loadConfig = config => ({
  type: c.load,
  payload: config
});
